import React from 'react'
import logo from "../../../assets/logo.png"

const ControlContainer = ({ children, customStyle, protocol, viewMode }) => {
    if (protocol !== "PC") {
        return (
            <div className="col-xs-12 col-md-3">
                <div className={customStyle}>
                    {children}
                </div>
            </div>
        )
    }

    return (
        <div className={viewMode === "double" ? "col-xs-12 col-md-12 pc-controlContainerDouble" : "col-xs-12 col-md-3 pc-controlContainerSingle"}>
            <div className={viewMode === "double" ? "logo-container-autonomous-pc" : 'logo-container-autonomous-pc-single'}>              
                <div className='logo-container-flex'>
                    <img src={logo} alt="logo" className='logo-large' />  &nbsp; &nbsp;
                    <div ><span className='logo-title-large'>VisualSense</span> <br /><span>&nbsp; Lyon, France</span></div>
                </div>
            </div>
            <div className={customStyle}>
                {children}
            </div>
        </div>
    )
}

export default ControlContainer